import {BASE,ApiError} from './api';
export const csvOriginalUrl=(id:string)=>BASE+'api/v1/csv-sources/'+encodeURIComponent(id)+'/original';
/** Read the retained UTF-8 original without stripping BOM or changing line endings. */
export async function readCsvOriginal(id:string,signal?:AbortSignal):Promise<string>{
 const response=await fetch(csvOriginalUrl(id),{signal,credentials:'same-origin',headers:{'X-Way-Request':'app'}});
 if(!response.ok){const body=await response.json().catch(()=>null);throw new ApiError(body?.error?.code||'REQUEST_FAILED',body?.error?.message||`The original could not be read (${response.status}).`,body?.error?.details,response.status);}
 return new TextDecoder('utf-8',{fatal:true,ignoreBOM:true}).decode(await response.arrayBuffer());
}
